import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider,isLoggedIn,useApp } from './AppContext';

// 아이프레임(앤츠톡 데스크탑 등)에 임베드된 경우 → 강제 최소폭(.App min-width:1660) 해제
try {
  if (window.self !== window.top) document.documentElement.classList.add('embedded');
} catch (e) {
  document.documentElement.classList.add('embedded');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <BrowserRouter>
    <AppProvider>
      <App />
      </AppProvider>
    </BrowserRouter>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();